import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { ERROR_GET_CUSTOM_FIELDS_SERVER } from '@/app/module/custom-fields/definitions'
import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useGetCustomFields = () => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)
  const res = esApi.endpoints.getOrgCustomfields.useQuery({ orgId: orgId.toString() }, { skip: !orgId })

  useEffect(() => {
    if (!res.error) {
      return
    }
    dispatch(
      createNotification({
        'get-receipts': {
          type: 'error',
          message: ERROR_GET_CUSTOM_FIELDS_SERVER,
        },
      }),
    )
  }, [res.error, dispatch])

  return res
}
